import api from './apiService';
import { applyQueryParams } from '../utils/helpers';

class Report {
  static exportStudents(filters, type, title) {
    const params = [
      { prop: 'cycle', value: filters.cycle },
      { prop: 'grade_instance', value: filters.gradeInstance },
      { prop: 'agreement', value: filters.agreement },
      { prop: 'bid', value: filters.bid },
    ];
    const data = { type, title };
    return api.post(applyQueryParams('/students/export_excel', params), data);
  }

  static getReports() {
    return api.get('/reports');
  }

  static exportStudentPdf(id) {
    return api.get(`/students/${id}/export_pdf`);
  }
}

export default Report;



// WEBPACK FOOTER //
// ./src/api/reportApi.js